import getAppId from '../helpers/getAppId';
import { themeSelector } from './themes';
import { AppTheme } from './types';

export const getTheme = (): AppTheme => {
  const appId = getAppId();

  return themeSelector[appId] || themeSelector['default'];
};
